import type { IComponentOptions } from "angular";
import { SubmitButtonComponentController } from "./SubmitButtonComponentController";

import "../Common/Button.scss";
import { ButtonComponent } from "../Common/ButtonComponent";
import "./SubmitButton.html";
import "./SubmitButton.scss";

export class SubmitButtonComponent extends ButtonComponent implements IComponentOptions {
    public controller = SubmitButtonComponentController;

    public templateUrl = "/App/Modules/Gui/Components/Button/SubmitButton/SubmitButton.html";

    public require: any;

    constructor() {
        super();

        this.bindings = {
            ...this.bindings,
            onSubmit: "&?",
        };

        this.require = {
            formCtrl: "^^form",
        };
    }
}
